var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOfNights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4426 18.7762C28.635 21.4124 27.0166 23.7267 24.8176 25.3899C22.8869 26.843 20.5895 27.7292 18.1831 27.9491C15.7767 28.169 13.3567 27.7139 11.1947 26.6348C9.03261 25.5557 7.2141 23.8954 5.94324 21.8402C4.67238 19.785 3.99948 17.4163 4.00006 14.9999C3.99137 12.1795 4.90826 9.43408 6.61006 7.18491C8.27323 4.9859 10.5876 3.36746 13.2238 2.55991C13.3976 2.50641 13.5826 2.50128 13.759 2.54509C13.9355 2.58889 14.0966 2.67997 14.2252 2.80852C14.3537 2.93707 14.4448 3.09823 14.4886 3.27467C14.5324 3.45111 14.5273 3.63616 14.4738 3.80991C13.8974 5.71669 13.849 7.74415 14.334 9.67624C14.8189 11.6083 15.8189 13.3727 17.2275 14.7812C18.6361 16.1898 20.4004 17.1898 22.3325 17.6748C24.2646 18.1597 26.292 18.1114 28.1988 17.5349C28.3726 17.4814 28.5576 17.4763 28.734 17.5201C28.9105 17.5639 29.0716 17.655 29.2002 17.7835C29.3287 17.9121 29.4198 18.0732 29.4636 18.2497C29.5074 18.4261 29.5023 18.6112 29.4488 18.7849L29.4426 18.7762Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOfNights);
export default __webpack_public_path__ + "static/media/no_of_nights.37b279f0f95bb2e89a81d2c74ad4a648.svg";
export { ForwardRef as ReactComponent };